import { IconButton, Tooltip } from '@dixa/lib-shared-habla';
import { ampli } from 'lib-shared-tracking';

import { AppState } from 'bootstrap.store';
import { activityLogActions } from 'components/activityLog/actions/activityLog';
import { CommandKeybindingsTooltipContent } from 'components/commandKeybindingsTooltipContent';
import { useCommandHandler } from 'utils/commands';
import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

export const ConversationActivityLogButton = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const isActivityLogOpen = useAppSelector(
    (state: AppState) => state.activityLog.isOpen,
  );

  useCommandHandler({
    name: 'conversation:activityLog',
    actionFn: () => {
      toggleActivityLog();
    },
  });

  const toggleActivityLog = () => {
    const open = !isActivityLogOpen;

    dispatch(activityLogActions.toggle({ open }));

    if (open) {
      ampli.conversationActivityLogOpened({ context: 'conversation' });
    } else {
      ampli.conversationActivityLogClosed();
    }
  };

  const tooltipContent = (
    <CommandKeybindingsTooltipContent commandName="conversation:activityLog">
      Activity log
    </CommandKeybindingsTooltipContent>
  );

  return (
    <Tooltip dark content={tooltipContent}>
      <IconButton
        data-testid="activity-log-button"
        icon="activity"
        variant="tertiary"
        active={isActivityLogOpen}
        onClick={toggleActivityLog}
      />
    </Tooltip>
  );
};
